import React, { useMemo, useState, useRef } from "react";
import { BsRobot, BsThreeDotsVertical } from "react-icons/bs";
//libraries
import {
  Button,
  Space,
  Table,
  Tag,
  Modal,
  Tooltip,
  Switch,
  Avatar,
  message,
  Dropdown,
  Menu,
  Input,
  Pagination,
} from "antd";
import {
  AiOutlineDelete,
  AiOutlineEdit,
  AiOutlineArrowUp,
  AiOutlineCode,
} from "react-icons/ai";
import { CopyOutlined, SyncOutlined } from "@ant-design/icons";
import { CopyToClipboard } from "react-copy-to-clipboard";
import DebouncedSearchInput from "../../Pages/SuperAdmin/Organizations/DebouncedSearchInput";
import { SEARCH_ALL_USER_CREATED_ASSISTANTS_SLUG } from "../../constants/Api_constants";
import { axiosSecureInstance } from "../../api/axios";
import { useEffect } from "react";
import { getUserID, getUserRole } from "../../Utility/service";
import {
  handleSwitchChange,
  showDeleteConfirm,
  showRemoveConfirm,
} from "../../Utility/showModalHelper";
import "./Assistant.css";
import { handleCheckAssistantActive } from "../../Utility/addPublicAssistantHelper";
import { FileContext } from "../../contexts/FileContext";
import { useContext } from "react";
import { BiFlag, BiSolidFlag, BiSolidLock, BiSolidLockOpen } from "react-icons/bi";
import { IoChatbubbleEllipsesOutline, IoCloseCircle } from "react-icons/io5";
import { IoIosCheckmarkCircle } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { generateEmbedCode } from "../../constants/Api_constants";
import ProfileHeader from "../Proflie/ProfileHeader";
import { RxCrossCircled } from "react-icons/rx";
import { CiCircleCheck } from "react-icons/ci";
import { generateIndustryColorMap } from "../../Utility/industryColorUtils";
const { confirm } = Modal;

const AdminAssistantList = ({ data }) => {
  const {
    setAdminUserAssistants,
    adminUserAssistants,
    loader,
    handleDeleteAssistant,
    handleUpdateAssistant,
    showEditModalHandler,
    handleFetchUserCreatedAssistants,
    totalCount,
    updateLoader,
    searchPersonalAssistants,
    personalAssistantSearchQuery,
    setPersonalAssistantSearchQuery,
    handlePublicAssistantAdd,
    getAssistantInfo,
  } = data;

  const [searchQuery, setSearchQuery] = useState("");
  const [isPublic, setIsPublic] = useState(false);
  const { isEditPageLoading, setIsEditPageLoading } = useContext(FileContext);
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [filteredInfo, setFilteredInfo] = useState({});
  const [sortedInfo, setSortedInfo] = useState({});
  const searchInputRef = useRef(null);
  const navigate = useNavigate();
  const redirectToAssistant = (record) => {
    const assistantId = record.assistant_id;
    const url = `/agents/${assistantId}`;
    window.open(url, "_blank");
  };

  const redirectToCustomEmbed = (record) => {
    const assistantId = record.assistant_id;
    const url = `/customize-embed-code/${assistantId}`;
    window.open(url, "_blank");
  };

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [copied, setCopied] = useState(false);
  const baseURL = process.env.REACT_APP_FE_URL;

  const openModal = (record) => {
    setSelectedRecord(record);
    setIsModalVisible(true);
  };

  const handleCopy = () => {
    setCopied(true);
    message.success("Embed code copied!");
    setTimeout(() => setCopied(false), 2000);
  };

  useEffect(() => {
    handleFetchUserCreatedAssistants(
      currentPage,
      personalAssistantSearchQuery,
      pageSize
    );
  }, [currentPage, personalAssistantSearchQuery, pageSize]);

  const navigateToCustomizationPage = (assistantName, assistantId) => {
    navigate(`/customize-embed-code/${assistantId}`);
  };

  const showDeleteConfirm = (assistantId, assistantName) => {
    confirm({
      title: "Are you sure delete this Agent?",
      content: `You are deleting ${assistantName}.`,
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk() {
        handleDeleteAssistant(
          assistantId,
          currentPage,
          personalAssistantSearchQuery,
          pageSize
        );
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  const industryColorMap = useMemo(() => {
    const industryList = adminUserAssistants.map(item => item.industryTypes);
    return generateIndustryColorMap(industryList);
  }, [adminUserAssistants]);

  const getIndustryTagColor = (industryType) => {
    return industryColorMap[industryType || "N/A"] || "default";
  };


  const createActionMenu = (record) => {
    return (
      <Menu>
        {
          <Menu.Item key="chat">
            <span
              style={{ display: "flex", alignItems: "center", gap: "8px" }}
              onClick={() => redirectToAssistant(record)}
            >
              <IoChatbubbleEllipsesOutline /> Chat with Agent
            </span>
          </Menu.Item>
        }
        {
          <Menu.Item key="edit">
            <span
              style={{ display: "flex", alignItems: "center", gap: "8px" }}
              onClick={async () => {
                setIsEditPageLoading(true);
                const isExisting = await getAssistantInfo(record?.assistant_id);
                if (isExisting) {
                  await showEditModalHandler(record);
                  // Fetch assistants after editing
                  handleFetchUserCreatedAssistants(
                    currentPage,
                    personalAssistantSearchQuery,
                    pageSize
                  );
                } else {
                  setIsEditPageLoading(false);
                }
              }}
            >
              <AiOutlineEdit /> Edit Agent
            </span>
          </Menu.Item>
        }

        {
          <Menu.Item key="activate">
            <span
              style={{ display: "flex", alignItems: "center", gap: "8px" }}
              onClick={async () => {
                await handleSwitchChange(
                  record,
                  !record?.is_active,
                  handleUpdateAssistant
                );
                // Refetch assistants
                handleFetchUserCreatedAssistants(
                  currentPage,
                  personalAssistantSearchQuery,
                  pageSize
                );
              }}
            >
              {record?.is_active ? <RxCrossCircled /> : <CiCircleCheck />} Make{" "}
              {record?.is_active ? "Deactivate" : "Activate"}
            </span>
          </Menu.Item>
        }
        {
          <Menu.Item key="public">
            <span
              style={{ display: "flex", alignItems: "center", gap: "8px" }}
              onClick={async () => {
                await handleCheckAssistantActive(
                  !record?.is_public,
                  record,
                  handlePublicAssistantAdd
                );
                handleFetchUserCreatedAssistants(
                  currentPage,
                  personalAssistantSearchQuery,
                  pageSize
                );
              }}
            >
              {record?.is_public ? <BiSolidLock /> : <BiSolidLockOpen />} Make{" "}
              {record?.is_public ? "Private" : "Public"}
            </span>
          </Menu.Item>
        }
        {getUserRole() === "superadmin" && (
          <Menu.Item key="flag-industrial">
            <span
              style={{ display: "flex", alignItems: "center", gap: "8px" }}
              onClick={async () => {
                try {
                  if (!record || !record.assistant_id) {
                    console.error("Missing record or assistant_id:", record);
                    return;
                  }
                  const updatedValue = !record.isIndustrialAgent;
 
                  await handleUpdateAssistant(
                    record,
                    { isIndustrialAgent: updatedValue },
                    currentPage,
                    personalAssistantSearchQuery,
                    pageSize
                  );


                  console.log("Successfully updated. Refetching assistants...");
                  handleFetchUserCreatedAssistants(
                    currentPage,
                    personalAssistantSearchQuery,
                    pageSize
                  );
                } catch (error) {
                  console.error("Error while toggling industrial flag:", error);
                }
              }}
            >
              {record?.isIndustrialAgent ? <BiSolidFlag /> : <BiFlag />}{" "}
              {record?.isIndustrialAgent ? "Unflag Industrial Agent" : "Flag Industrial Agent"}
            </span>
          </Menu.Item>
        )}


        {
          <Menu.Item key="embed">
            <span
              style={{ display: "flex", alignItems: "center", gap: "8px" }}
              onClick={() => openModal(record)}
            >
              <IoChatbubbleEllipsesOutline /> Generate Embedded Code
            </span>
          </Menu.Item>

        }
        {
          <Menu.Item key="embed">
            <span
              style={{ display: "flex", alignItems: "center", gap: "8px" }}
              onClick={() => redirectToCustomEmbed(record)}
            >
              <AiOutlineCode /> Get Custom Embedded Code
            </span>
          </Menu.Item>

        }
        {
          <Menu.Item key="delete" danger>
            <span
              style={{ display: "flex", alignItems: "center", gap: "8px" }}
              onClick={() =>
                showDeleteConfirm(
                  record?.assistant_id,
                  record?.name,
                  handleDeleteAssistant
                )
              }
            >
              <AiOutlineDelete /> Delete
            </span>
          </Menu.Item>
        }
      </Menu>
    );
  };

  const handleChange = (pagination, filters, sorter) => {
    setFilteredInfo(filters);
    setSortedInfo(sorter);
  };

  const clearFilters = () => {
    setFilteredInfo({});
    setPersonalAssistantSearchQuery('');
    setSearchQuery('');
    if (searchInputRef.current) {
      searchInputRef.current.input.setValue('');
    }
  };

  const clearAll = () => {
    setFilteredInfo({});
    setSortedInfo({});
    setPersonalAssistantSearchQuery('');
    setSearchQuery('');
    if (searchInputRef.current) {
      searchInputRef.current.input.setValue('');
    }
  };

  const formatDate = (date, fallbackText = "Invalid Date") => {
    if (!date || isNaN(Date?.parse(date))) {
      return fallbackText;
    }
    return new Date(date)?.toLocaleDateString("en-US", {
      year: "2-digit",
      month: "2-digit",
      day: "2-digit",
    });
  };

  const sortDateDescending = (firstItem, secondItem, key) =>
    new Date(secondItem[key]) - new Date(firstItem[key]);

  const sortBoolean = (firstItem, secondItem, key) => {
    return firstItem[key] === secondItem[key] ? 0 : firstItem[key] ? -1 : 1;
  };

  const columns = [
    {
      title: "Agent",
      dataIndex: "name",
      key: "name",
      align: "left",
      width: "20%",
      render: (_, { name, image_url }) => (
        <Space size="middle" className="d-flex align-items-center">
          <div className="assistantImageDiv">
            {image_url ? (
              <img src={image_url} className="customImage" alt="avatar" />
            ) : (
              <BsRobot className="customImage" />
            )}
          </div>
          <div className="ms-2 text-start">{name}</div>
        </Space>
      ),
      sorter: (firstAssistant, secondAssistant) =>
        firstAssistant.name.localeCompare(secondAssistant.name),
      sortOrder: sortedInfo?.columnKey === "name" ? sortedInfo?.order : null,
    },
    
    getUserRole() === "superadmin" && ({
      title: "Industry",
      dataIndex: "industryTypes",
      key: "industryTypes",
      align: "center",
      width: "12%",
      render: (industryTypes) => {
        const industries = Array.isArray(industryTypes)
          ? industryTypes
          : [industryTypes || "N/A"];
        return industries.map((type) => (
          <Tag key={type} color={getIndustryTagColor(type)}>
            {type}
          </Tag>
        ));
      },
      sortOrder: sortedInfo.columnKey === "industryTypes" ? sortedInfo.order : null,
      filters: [
        ...new Set(
          adminUserAssistants
            .map((item) => item.industryTypes || "N/A")
            .flat()
            .filter((type) => type)
        ),
      ].map((type) => ({
        text: type,
        value: type,
      })),
      filteredValue: filteredInfo.industryTypes || null,
      onFilter: (value, record) => {
        const industryValues = Array.isArray(record.industryTypes)
          ? record.industryTypes
          : [record.industryTypes || "N/A"];
        return industryValues.includes(value);
      },
    }),
    // {
    //   title: "Model & Tools",
    //   dataIndex: "model",
    //   key: "modelAndTools",
    //   align: "left",
    //   width: "18%",
    //   render: (_, { model, tools }) => (
    //     <Space direction="vertical" size="small">
    //       <Tag color="blue">
    //         {Array.isArray(model) && model.length > 0
    //           ? model[0]
    //           : model || "No model specified"}
    //       </Tag>
    //       <div className="modeltools-column">
    //         {Array.isArray(tools) && tools.length > 0 ? (
    //           tools.map((tool, index) => (
    //             <Tag key={index} color="green">
    //               {tool?.name || tool?.type || "Unknown tool"}
    //             </Tag>
    //           ))
    //         ) : (
    //           <span>No tools enabled</span>
    //         )}
    //       </div>
    //     </Space>
    //   ),
    // },
    {
      title: "Type",
      key: "type",
      align: "center",
      width: "10%",
      render: (_, { tools }) => (
        <Tag color={tools?.length > 0 ? "geekblue" : "purple"}>
          {tools?.length > 0 ? "Agent" : "Assistant"}
        </Tag>
      ),
      filters: [
        { text: "Agent", value: "agent" },
        { text: "Assistant", value: "assistant" },
      ],
      filteredValue: filteredInfo?.type || null,
      onFilter: (value, record) => {
        if (value === "agent") return record.tools?.length > 0;
        if (value === "assistant")
          return !record?.tools || record?.tools?.length === 0;
        return true;
      },
    },
    {
      title: "Creation Date",
      dataIndex: "createdAt",
      key: "createdAt",
      align: "center",
      width: "12%",
      render: (date) => <span>{formatDate(date)}</span>,
      sorter: (firstRecord, secondRecord) =>
        sortDateDescending(firstRecord, secondRecord, "createdAt"),
      sortOrder:
        sortedInfo?.columnKey === "createdAt" ? sortedInfo?.order : null,
    },
    {
      title: "Last Updated",
      dataIndex: "updatedAt",
      key: "updatedAt",
      align: "center",
      width: "12%",
      render: (date) => <span>{formatDate(date, "Not updated")}</span>,
      sorter: (firstRecord, secondRecord) =>
        sortDateDescending(firstRecord, secondRecord, "updatedAt"),
      sortOrder:
        sortedInfo?.columnKey === "updatedAt" ? sortedInfo?.order : null,
    },
    {
      title: "Status",
      key: "is_active",
      align: "center",
      dataIndex: "is_active",
      width: "10%",
      render: (_, { is_active }) => (
        <Tag color={is_active ? "green" : "red"}>
          {is_active ? "Active" : "Inactive"}
        </Tag>
      ),
      sorter: (firstRecord, secondRecord) =>
        sortBoolean(firstRecord, secondRecord, "is_active"),
      sortOrder:
        sortedInfo?.columnKey === "is_active" ? sortedInfo?.order : null,
    },
    {
      title: "Published",
      key: "is_public",
      align: "center",
      dataIndex: "is_public",
      width: "10%",
      render: (_, { is_public }) => (
        <Tag color={is_public ? "blue" : "gray"}>
          {is_public ? "Public" : "Private"}
        </Tag>
      ),
      sorter: (firstRecord, secondRecord) =>
        sortBoolean(firstRecord, secondRecord, "is_public"),
      sortOrder:
        sortedInfo?.columnKey === "is_public" ? sortedInfo?.order : null,
    },
    {
      title: "Action",
      key: "action",
      align: "center",
      width: "10%",
      render: (_, record) => (
        <Space size="middle">
          <Dropdown overlay={createActionMenu(record)} trigger={["click"]}>
            <a onClick={(e) => e.preventDefault()}>
              <Space>
                <BsThreeDotsVertical />
              </Space>
            </a>
          </Dropdown>
          {/* <Button
            onClick={() => redirectToAssistant(record)}
            icon={<AiOutlineArrowUp />}
          ></Button>

          <Button
            onClick={async() => {
              setIsEditPageLoading(true);
              const isExisting = await getAssistantInfo(record?.assistant_id);
              if(isExisting){
                await showEditModalHandler(record);
              }else{
                setIsEditPageLoading(false);

              }
            
            }}
            icon={<AiOutlineEdit /> } 
          >

          </Button>
          <Tooltip title="Activate or Deactivate">
            <Switch
              checked={record?.is_active}
              onChange={async (checked) =>

                await handleSwitchChange(record, checked, handleUpdateAssistant)

              }
              loading={
                loader.ASSISTANT_UPDATING === record._id ?? false
              }

            />
          </Tooltip>
          <Button
            onClick={() => showDeleteConfirm(record?.assistant_id, record?.name,handleDeleteAssistant)}
            danger
            icon={<AiOutlineDelete />}
            loading={
              loader.ASSISTANT_DELETING === record._id
            }

          />
          <Tooltip title="Public or Private">
            <Switch
              checked={record?.is_public}
              onChange={(checked) =>{handleCheckAssistantActive(checked, record, handlePublicAssistantAdd)}
              }
              loading={
                loader.ASSISTANT_UPDATING === record._id ?? false
              }

            />
          </Tooltip> */}
        </Space>
      ),
    },
  ].filter(Boolean);

  return (
    <>
      <Modal
        title="Full Embed Code"
        open={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        footer={null}
      >
        {selectedRecord && (
          <>
            <Input.TextArea
              value={generateEmbedCode(selectedRecord, baseURL)}
              readOnly
              autoSize={{ minRows: 3, maxRows: 6 }}
            />
            <CopyToClipboard text={generateEmbedCode(selectedRecord, baseURL)} onCopy={handleCopy}>
              <Button type="primary" style={{ marginTop: "10px", width: "100%" }}>
                {copied ? "Copied!" : "Copy Embed Code"}
              </Button>
            </CopyToClipboard>
          </>
        )}
      </Modal>
      <div className="mb-3">
        <ProfileHeader
          title="My Agents"
          subHeading="List of agents created by you."
        />
        <div className="searchbox-container">
          <div className="searchbox-wrapper">
            <DebouncedSearchInput
              ref={searchInputRef}
              data={{
                search: personalAssistantSearchQuery,
                setSearch: setPersonalAssistantSearchQuery,
                placeholder: "Search agents",
              }}
            />
          </div>
          <Pagination
            current={currentPage}
            pageSize={pageSize}
            total={totalCount}
            showSizeChanger={true}
            onShowSizeChange={(current, size) => {
              setPageSize(size);
              setCurrentPage(1);
            }}
            onChange={(page) => setCurrentPage(page)}
            showTotal={(total, range) =>
              `${range[0]}-${range[1]} of ${total} items`
            }
          />
        </div>
      </div>
      <Space style={{ marginBottom: 16 }}>
        <Button onClick={clearFilters}>Clear filters</Button>
        <Button onClick={clearAll}>Clear filters and sorters</Button>
      </Space>
      <Table
        loading={loader.ASSISTANT_LOADING || isEditPageLoading}
        columns={columns}
        dataSource={adminUserAssistants}
        onChange={handleChange}
        scroll={{ y: "50vh" }}
        className={`${loader.ASSISTANT_LOADING ||
          isEditPageLoading ||
          adminUserAssistants?.length === 0
          ? "mt-2"
          : ""
          }`}
        pagination={false}
      />
    </>
  );
};

export default AdminAssistantList;
